import {StyleSheet} from 'aphrodite';

import {GRAY_SEMIDARK} from 'ui-library/Colors';

export const spinKeyframes = {
  '0%': {transform: 'rotate(0deg)'},
  '100%': {transform: 'rotate(360deg)'},
};

export const sharedStyles = StyleSheet.create({
  spinningIcon: {
    animationName: [spinKeyframes],
    animationDuration: '1s',
    animationIterationCount: 'infinite',
    animationTimingFunction: 'linear',
  },
  loadingState: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 12,
    padding: 40,
    color: GRAY_SEMIDARK,
  },
});

export type McpToolPermissionValue = 'AUTO' | 'DISABLED';

export const getPermissionLabel = (permission: McpToolPermissionValue | null): string => {
  switch (permission) {
    case 'AUTO':
      return 'Granted';
    case 'DISABLED':
      return 'Not Granted';
    default:
      return 'Not Configured';
  }
};
